"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.post = post;
function post(url_1) {
    return __awaiter(this, arguments, void 0, function* (url, obj = {}) {
        var _a, _b;
        const r = yield fetch(url, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': (_b = (_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) !== null && _b !== void 0 ? _b : '',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(obj),
        });
        return yield r.json();
    });
}
